import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_effect } from '@/hooks/_base/use_effect';
import { useToast } from '@/hooks/use-toast';
import i18n_errors from '@/locales/keys/i18n_errors.json';
import { ENUM__local_event } from '@/services/events/ENUM__local_event';
import { service_local_events } from '@/services/events/service_local_events';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { service_socketio_client } from '@/services/socketio_client_react/service_socketio_client';
import { timestamp_ms } from '@shared/utils/utils_time';
import { useTranslation } from 'react-i18next';
import { ButtonCopyError } from '../../buttons/button_copy_error';

export function WatcherResponseError() {
  const { t } = useTranslation(ENUM__i18n_namespace.ERRORS);

  const { toast } = useToast();

  /*
   * EFFECTS
   */

  use_effect(() => {
    service_local_events.on(ENUM__local_event.RESPONSE_ERROR_RECEIVED, onResponseErrorReceived);

    return () => service_local_events.off(ENUM__local_event.RESPONSE_ERROR_RECEIVED, onResponseErrorReceived);
  });

  /*
   * EVENTS
   */
  function onResponseErrorReceived() {
    for (let error of service_socketio_client.errors) {
      const title = t(i18n_errors.toast_title_response_error);
      const description = t(i18n_errors.all_errors[error.type], error.info) as string;
      const received_at = timestamp_ms();

      toast({
        title,
        description,
        action: (
          <div id={'button-copy-error'} className="absolute top-[55%] -translate-y-1/2 right-[5px]">
            <ButtonCopyError {...{ title, description, received_at, info: error.info }} />
          </div>
        ),
        duration: CONSTANTS_TIME__client.TOAST_DURATION_ERROR,
      });
    }

    service_socketio_client.errors.length = 0;
  }

  return null;
}
